import type { SignUpConfig } from '#types/config/components/form/signUp'

export default {
  brandClasses: {
    checkboxesWrapper: 'space-y-2',
    heading: 'subtitle-1',
    passwordRequirements: 'mb-2',
    submitButton: 'mt-2 w-full'
  },
  isBirthDateRequired: true,
  isLoyaltyNewsletterAllowed: true,
  isSmsOptInRequired: true,
  mobilePhone: {},
  showMobilePhoneField: true
} satisfies Partial<SignUpConfig>
